import axiosInstance from '../lib/axios'
import { API_ENDPOINTS } from '../constants/api'
import type { Device, DeviceCreate, DeviceUpdate } from '../types/api.types'

export const platformDevicesService = {
  async getByOrg(orgId: number, propertyId?: number): Promise<Device[]> {
    const { data } = await axiosInstance.get<Device[]>(
      API_ENDPOINTS.PLATFORM_ORG_DEVICES(orgId, propertyId),
    )
    return data
  },

  async create(orgId: number, payload: DeviceCreate): Promise<Device> {
    const { data } = await axiosInstance.post<Device>(
      API_ENDPOINTS.PLATFORM_ORG_DEVICES(orgId),
      payload,
    )
    return data
  },

  async update(orgId: number, deviceId: number, payload: DeviceUpdate): Promise<Device> {
    const { data } = await axiosInstance.put<Device>(
      API_ENDPOINTS.PLATFORM_ORG_DEVICE(orgId, deviceId),
      payload,
    )
    return data
  },

  async delete(orgId: number, deviceId: number): Promise<void> {
    await axiosInstance.delete(API_ENDPOINTS.PLATFORM_ORG_DEVICE(orgId, deviceId))
  },
}
